
import React, { useState } from 'react';

const CreativeDesignSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('Malerarbeiten');
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const categories = {
    'Malerarbeiten': [
      'https://i.imgur.com/YourImage1.jpg',
      'https://i.imgur.com/YourImage2.jpg',
      'https://i.imgur.com/YourImage3.jpg',
      'https://i.imgur.com/YourImage4.jpg',
      'https://i.imgur.com/YourImage5.jpg',
      'https://i.imgur.com/YourImage6.jpg'
    ],
    'Trockenbau': [
      'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/ec8150fd27e86e64ac5323abb2b8043b.jfif'
    ],
    'Renovierung': [
      'https://public.readdy.ai/ai/img_res/2faab778d4239ade7796b7827aaef2cc.jpg',
      'https://readdy.ai/api/search-image?query=kitchen%20renovation%20with%20white%20cabinets%2C%20marble%20countertops%2C%20modern%20appliances%2C%20clean%20design%2C%20bright%20lighting&width=800&height=600&seq=renovation2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=living%20room%20renovation%20with%20modern%20furniture%2C%20neutral%20colors%2C%20clean%20lines%2C%20bright%20natural%20lighting&width=800&height=600&seq=renovation3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=bedroom%20renovation%20with%20minimalist%20design%2C%20white%20walls%2C%20modern%20furniture%2C%20clean%20aesthetic&width=800&height=600&seq=renovation4&orientation=landscape',
      'https://readdy.ai/api/search-image?query=home%20office%20renovation%20with%20modern%20desk%2C%20ergonomic%20chair%2C%20clean%20organization%2C%20bright%20lighting&width=800&height=600&seq=renovation5&orientation=landscape',
      'https://readdy.ai/api/search-image?query=hallway%20renovation%20with%20modern%20flooring%2C%20clean%20walls%2C%20contemporary%20lighting%20fixtures&width=800&height=600&seq=renovation6&orientation=landscape'
    ]
  };

  const designServices = [
    {
      icon: 'ri-printer-line',
      title: 'Werbedruck',
      description: 'Professioneller Druck von Flyern, Visitenkarten und Werbematerialien'
    },
    {
      icon: 'ri-palette-line',
      title: 'Kreatives Design',
      description: 'Individuelle Gestaltung von Logos, Grafiken und Werbedesign'
    },
    {
      icon: 'ri-image-line',
      title: 'Werbegrafik',
      description: 'Ansprechende Werbegrafiken für Print und digitale Medien'
    }
  ];

  return (
    <section className="py-20 bg-green-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            Jo Kreativ Design
          </h2>
          <p className="text-xl text-green-100 max-w-3xl mx-auto">
            Kreatives & Werbedruck - Ihre Ideen professionell umgesetzt
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {designServices.map((service, index) => (
            <div 
              key={index}
              className="bg-gray-800/50 border border-gray-700 rounded-xl p-8 hover:border-green-400 hover:shadow-xl transition-all duration-300 cursor-pointer group text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-green-700 rounded-full mx-auto mb-6 group-hover:bg-green-500 transition-colors duration-300">
                <i className={`${service.icon} text-3xl text-green-100 group-hover:text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">
                {service.title}
              </h3>
              <p className="text-gray-300">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gray-900/40 border border-gray-700 rounded-2xl p-8 backdrop-blur-sm">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-white mb-4">
                Lassen Sie Ihre Ideen Wirklichkeit werden
              </h3>
              <p className="text-green-100 mb-6">
                Von der ersten Idee bis zum fertigen Produkt - wir begleiten Sie bei 
                allen kreativen Projekten und sorgen für professionelle Umsetzung.
              </p>
              <button 
                onClick={() => {
                  const element = document.querySelector('#contact');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="whitespace-nowrap cursor-pointer bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors duration-200"
              >
                Design anfragen
              </button>
            </div>
            <div className="text-center">
              <img 
                src="https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/e9e613799a4fffd3d4219c73254372a0.jpeg"
                alt="Jo Kreativ Design Workspace"
                className="rounded-lg shadow-lg object-cover w-full h-64"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreativeDesignSection;
